import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Notification, NotificationAuthorizations, NotificationsPage } from '../../core/services/notifications.service';

export const notificationApiActions = createActionGroup({
  source: 'Notifications API',
  events: {
    'Notifications Request': props<{ benId: number, page: number }>(),
    // Igual que Request pero sin pasar por isLoading: se usa al recibir un push.
    'Notifications Refresh': props<{ benId: number, page: number }>(),
    'Notifications Success': props<{ notifications: NotificationsPage }>(),
    'Notifications Failure': props<{ error: string }>(),

    'Notifications Authorizations Request': props<{ benId: number }>(),
    'Notifications Authorizations Success': props<{ notifications: NotificationAuthorizations[] }>(),
    'Notifications Authorizations Failure': props<{ error: string }>(),

    'Notification Detail Request': props<{ id: number }>(),
    'Notification Detail Success': props<{ notification: Notification }>(),
    'Notification Detail Failure': props<{ error: string }>(),

    'Notification Read Request': props<{ benId: number, id: number }>(),
    'Notification Read Success': props<{ id: number }>(),
    'Notification Read Failure': props<{ error: string }>(),

    'Unread Count Request': props<{ benId: number }>(),
    'Unread Count Success': props<{ unreadCount: number }>(),
    'Unread Count Failure': props<{ error: string }>(),

    // Push recibido con la pestaña abierta: refresca el contador y los listados visibles.
    'Push Received': emptyProps(),
  },
});
